import * as React from 'react';
import { Avatar, Row, Col } from './index';

interface Props {
  title: string | JSX.Element;
  imgSrc: string;
}

export const LeftAvatarRightTitle: React.SFC<Props> = props => (
  <Row type="flex" align="middle" justify="center">
    <Col span={4}>
      <Avatar
        style={{ maxWidth: 40, width: '100%' }}
        shape="square"
        size="large"
        icon="user"
        src={props.imgSrc}
      />
    </Col>
    <Col span={20}>{props.title}</Col>
  </Row>
);



// WEBPACK FOOTER //
// ./app/components/antd/LeftAvatarRightTitle.tsx